import { useState } from "react";

import { Col, FormCheck, FormControl, FormLabel, FormSelect, Row } from "react-bootstrap";

import RollDice from "../dice-rolling";
import { Link } from "react-router-dom";

export default function MissileAttacks() {
	const [weaponType, setWeaponType] = useState("Archer/Slinger");
	const [numAttackers, setNumAttackers] = useState(1);
	const [range, setRange] = useState(1);
	const [targetShipSize, setTargetShipSize] = useState("Very Small");
	const [targetShipSpeed, setTargetShipSpeed] = useState(0);
	const [firingShipSize, setFiringShipSize] = useState("Very Small");
	const [firingShipSpeed, setFiringShipSpeed] = useState(0);
	const [isFromLandFort, setIsFromLandFort] = useState(false);
	const [isFightingFire, setIsFigtingFire] = useState(false);
	const [missileAttackResults, setMissileAttackResults] = useState({ hits: 0, superHits: 0, weaponType: "", range: 1 });

	const archerSlingerTable: { damage: number, threshold: number }[] = [
		{ damage: 1, threshold: 7 },
		{ damage: 1, threshold: 9 },
	];

	const lightBalistaTable: { damage: number, threshold: number }[] = [
		{ damage: 2, threshold: 7 },
		{ damage: 1, threshold: 8 },
		{ damage: 1, threshold: 8 }
	];

	const medBalistaTable: { damage: number, threshold: number }[] = [
		{ damage: 3, threshold: 8 },
		{ damage: 2, threshold: 8 },
		{ damage: 2, threshold: 8 }
	];

	const heavyBalistaTable: { damage: number, threshold: number }[] = [
		{ damage: 5, threshold: 8 },
		{ damage: 5, threshold: 8 },
		{ damage: 3, threshold: 9 },
		{ damage: 3, threshold: 9 }
	];

	function GetCurentTable(): { damage: number, threshold: number }[] {
		let table: { damage: number, threshold: number }[] = archerSlingerTable;

		switch (weaponType) {
			case "Light Balista":
				table = lightBalistaTable;
				break;
			case "Medium Balista":
				table = medBalistaTable;
				break;
			case "Heavy Balista":
				table = heavyBalistaTable;
				break;
			default:
				break;
		}

		return table;
	}

	function rollToResolveMissileAttack() {
		const dieRolls: number[] = RollDice(numAttackers);
		let table: { damage: number, threshold: number } = GetCurentTable()[range - 1];
		let hits: number = 0;
		let superHits: number = 0;
		let drms: number = 0;

		// Target DRMs
		if (targetShipSize === "Very Small")
			drms -= 1;
		else if (targetShipSize === "Very Large" && weaponType !== "Archer/Slinger")
			drms += 1;
		if (targetShipSpeed >= 5)
			drms -= 1;

		// Firer DRMs
		if (isFromLandFort)
			drms += 1;
		else {
			if (firingShipSize === "Very Large" && weaponType !== "Archer/Slinger")
				drms += 1;
			if (firingShipSpeed >= 5)
				drms -= 1;
		}
		if (isFightingFire)
			drms -= 1;

		// Determine Results
		for (var i:number = 0; i < dieRolls.length; i++) {
			if (dieRolls[i] === 1)
				continue;
			if (dieRolls[i] === 10) {
				superHits++;
				continue;
			}

			let modifiedDieRoll = dieRolls[i] + drms;

			if (modifiedDieRoll >= table.threshold)
				hits += table.damage;
		}

		setMissileAttackResults({ hits: hits, superHits: superHits, weaponType: weaponType, range: range })
	}

	return (
		<>
			<Row>
				<Col>
					<h1>Missile Attacks</h1>
				</Col>
			</Row>
			{missileAttackResults.weaponType === "" || (missileAttackResults.hits + missileAttackResults.superHits) === 0 ? null : missileAttackResults.weaponType === "Archer/Slinger" ? (
				<Row className="p-3 text-center">
					<Col>
						<h3 className="text-danger">
							{missileAttackResults.hits} hits chosen by owner which can't hit Rowing Crew and {missileAttackResults.superHits} hits chosen by firer which may be able to hit Rowing Crew.
						</h3>
						<p><em><b>Note:</b> Archers/Slingers <b>DO NOT</b> inflict Hull/Oar Damage</em></p>
					</Col>
				</Row>
			) : (
				<Row className="p-3 text-center">
					<Col>
						<h3 className="text-danger">
							Roll {missileAttackResults.hits + missileAttackResults.superHits} times at range {missileAttackResults.range < 3 ? missileAttackResults.range : "3+"} on the <Link to="/artillery-hits-on-ships">Artillery Hits on Ships Table</Link>
						</h3>
					</Col>
				</Row>
			)}
			{missileAttackResults.weaponType === "" || (missileAttackResults.hits + missileAttackResults.superHits) != 0 ? null : (
				<Row className="p-3 text-center">
					<Col>
						<h3 className="text-success">No Hits</h3>
					</Col>
				</Row>
			)}
			<Row className="mt-3">
				<Col>
					<FormLabel htmlFor="weapon-type">Weapon Type</FormLabel>
					<FormSelect id="weapon-type" value={weaponType} onChange={(e) => setWeaponType(e.target.value)}>
						<option value="Archer/Slinger">Archers/Slingers</option>
						<option value="Light Balista">Light Balista</option>
						<option value="Medium Balista">Medium Balista</option>
						<option value="Heavy Balista">Heavy Balista</option>
					</FormSelect>
				</Col>
				<Col>
					<FormLabel htmlFor="weapon-count">Number Attacking</FormLabel>
					<FormControl id="weapon-count" type="number" min={1} value={numAttackers} onChange={(e) => setNumAttackers(parseInt(e.target.value))} />
				</Col>
				<Col>
					<FormLabel htmlFor="range">Range</FormLabel>
					<FormControl id="range" type="number" min={1} max={GetCurentTable().length} value={range} onChange={(e) => setRange(parseInt(e.target.value))} />
				</Col>
			</Row>
			<Row className="mt-3">
				<Col>
					<FormLabel htmlFor="target-size">Target Ship Size</FormLabel>
					<FormSelect id="target-size" value={targetShipSize} onChange={(e) => setTargetShipSize(e.target.value)}>
						<option value="Very Small">Very Small</option>
						<option value="Small">Small</option>
						<option value="Medium">Medium</option>
						<option value="Large">Large</option>
						<option value="Very Large">Very Large</option>
					</FormSelect>
				</Col>
				<Col>
					<FormLabel htmlFor="target-speed">Target Ship Speed</FormLabel>
					<FormControl id="target-speed" type="number" min={1} value={targetShipSpeed} onChange={(e) => setTargetShipSpeed(parseInt(e.target.value))} />
				</Col>
			</Row>
			<Row className="mt-3">
				<Col>
					<FormCheck type="checkbox" label="Firer is on Land/Fort" checked={isFromLandFort} onChange={(e) => setIsFromLandFort(e.target.checked)} />
				</Col>
			</Row>
			{isFromLandFort === true ? null : (
				<>
					<Row className="mt-3">
						<Col>
							<FormLabel htmlFor="firer-size">Firing Ship Size</FormLabel>
							<FormSelect id="firer-size" value={firingShipSize} onChange={(e) => setFiringShipSize(e.target.value)}>
								<option value="Very Small">Very Small</option>
								<option value="Small">Small</option>
								<option value="Medium">Medium</option>
								<option value="Large">Large</option>
								<option value="Very Large">Very Large</option>
							</FormSelect>
						</Col>
						<Col>
							<FormLabel htmlFor="firer-speed">Firing Ship Speed</FormLabel>
							<FormControl id="firer-speed" type="number" min={1} value={firingShipSpeed} onChange={(e) => setFiringShipSpeed(parseInt(e.target.value))} />
						</Col>
					</Row>
					<Row className="mt-3">
						<Col>
							<FormCheck type="checkbox" label="Firing Ship is Fighting a &quot;Substantial Fire&quot;" checked={isFightingFire} onChange={(e) => setIsFigtingFire(e.target.checked)} />
						</Col>
					</Row>
				</>
			)}
			<Row className="mt-3">
                <Col xs={12}>
                    <button className="btn btn-primary" onClick={() => rollToResolveMissileAttack()}>Roll to Resolve Missile Attack</button>
                </Col>
                <Col className="mt-3">
					<button className="btn btn-danger" onClick={() => setMissileAttackResults({ hits: 0, superHits: 0, weaponType: "", range: 1 })}>Clear Result</button>
                </Col>
            </Row>
		</>
	);
};